<template>
  <div>
    <div class="modal-content" >
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
        <h4 class="modal-title">Xuất Hóa Đơn Điện Tử</h4>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-xs-12">
            AAAAAAAAAAAAAA
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          style="background-color: #f29911;border-color: #f29911;color:#fff"
          type="button"
          class="btn btn-default pull-left"
          data-dismiss="modal"
        >{{$t('common.back')}}</button>
        <button
          type="button"
          class="btn btn-primary btn-green"
        >{{$t('common.save')}}</button>
      </div>
      <!-- /.modal-content -->
      <!-- <div class="modal fade" id="modal-confirm" ref="modal-confirm">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title">{{$t('apartment.reservations.checkout')}}</h1>
            </div>
            <div class="modal-body">
              <b-form>
                <b-form-group label-size="sm" label-for="input-sm" :label="$t('apartment.reservations.confirm_sure_checkout') + '?'"> 
                </b-form-group>
              </b-form>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-primary btn-sm pull-right"
                @click="onCheckOut(bookingData.id)"
              >{{$t('common.delete_modal.btnYes')}}</button>
              <button
                type="button"
                class='btn btn-warning btn-sm pull-left'
                @click="onHideModalCheckout()"
              >{{$t('common.back')}}</button>
            </div>
          </div>
        </div>    
      </div> -->
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
//import moment from "moment";
// import LTEModal from "@/components/LTEModal.vue";
// import LTECoreAlert from "@/components/LTESnackBar.vue";
// import Paginator from "@/components/Paginator.vue";
// import Loading from "vue-loading-overlay";
// import utils from '@/lib/utils';
// import booking from "@/components/LTEBooking";
// import datePicker from "vue-bootstrap-datetimepicker";
// import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
// import LTEModalBookingDetail from "@/components/LTEModalBookingDetail";
// import LeaseBackApartmentInputView from "./LeaseBackApartmentInputView"
// import LeaseBackTenantBooking from "./LeaseBackTenantBooking"
// import constants from "@/lib/constantsData"

export default {
  name: "ConvertToBKAV",
  props: {
  },
  data () {
    return {
    }
  },
  watch: {
  },
  computed: {
    ...mapGetters([
    ]),
  },
  methods: {
    ...mapActions([
    ])
  },
  components: {
  },
  mounted() {
  }
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/Invoice/ConvertToBKAV.vue